import React from "react";
import { Grid } from "@mui/material";
import { dashboardIcon, farmers } from "../../config/images";
import translations from "../../config/language";

const PersonalDetails = ({ selectedFarmer }) => {
  // const [firstName, middleName, lastName] = selectedFarmer.farmerName.split(" ");

  const personalDetails = selectedFarmer?.personal_details;
  const language = process.env.REACT_APP_LANGUAGE;
  return (
    <div className="user-profile">
      <Grid container spacing={2}>
        <Grid item lg={8} xs={12}>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ borderTop: "1px solid #D9D9D9", paddingLeft: "20px" }}
            >
              {translations[language].firstName}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}
            >
              {personalDetails?.first_name}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].middleName}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ fontWeight: 700 }}
            >
              {personalDetails?.middle_name}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].lastName}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ fontWeight: 700 }}
            >
              {personalDetails?.last_name}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].gender}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ fontWeight: 700 }}
            >
              {personalDetails?.gender == 0
                ? translations[language].male
                : translations[language].female}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].dateOfBirth}
            </Grid>
            <Grid item lg={8} xs={12} className="grid-item">
              <div style={{ display: "flex", gap: "10px", fontWeight: 700 }}>
                <div
                  style={{
                    paddingRight: "20px",
                    borderRight: "1px solid  #D9D9D9",
                  }}
                >
                  {personalDetails?.date_of_birth}
                </div>
                <div style={{ paddingLeft: "20px" }}>
                  {personalDetails?.age} years
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].mobileNumber}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ fontWeight: 700 }}
            >
              {personalDetails?.mobile_number}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].alternateMobileNumber}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ fontWeight: 700 }}
            >
              {personalDetails?.alternate_mobile_number}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].email}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ fontWeight: 700 }}
            >
              {personalDetails?.email}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={4}
              xs={12}
              className="grid-item"
              style={{ paddingLeft: "20px" }}
            >
              {translations[language].nationalIdentificationNo}
            </Grid>
            <Grid
              item
              lg={8}
              xs={12}
              className="grid-item"
              style={{ fontWeight: 700 }}
            >
              {personalDetails?.national_identification_number}
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={4}>
          {personalDetails?.farmer_photo ? (
            <img
              src={personalDetails?.farmer_photo}
              className="user-image"
              alt=""
            />
          ) : (
            <img
              src={dashboardIcon.profile}
              alt=""
              className="user-image"
              style={{ height: "316px", width: "100%" }}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default PersonalDetails;
